import {ClientReportSubmitInput} from "../../domain";
import {Controller, useFormContext} from "react-hook-form";
import {SimpleDropdown} from "common";
import {SPLIT_DELIMITER} from "placement/const";
import React from "react";

type ServiceTypeInputProps = {
    restrictedOptions: Map<string, string>;
    disabled: boolean;
    callback?: ((serviceType: string[]) => void) | null;
};

export function ServiceTypeSingleSelectInput({disabled, restrictedOptions, callback = null}: ServiceTypeInputProps) {
    const {
        setValue,
        clearErrors,
        control,
        formState: {
            errors
        },
    } = useFormContext<ClientReportSubmitInput>();

    return (
        <div className="text-black-200 pb-2 text-base">
            <div className="flex">
                <div className="flex items-center">
                    Service Types
                </div>
                <div className="ml-4 items-center">
                    <Controller
                        name="serviceType"
                        control={control}
                        rules={{
                            required: true
                        }}
                        render={({field: {value}}) => {
                            return (
                                <SimpleDropdown options={restrictedOptions}
                                                selected={value.join(SPLIT_DELIMITER)}
                                                textColor={'gray-600'}
                                                disabled={disabled}
                                                placeholder={'Please Choose'}
                                                setSelected={(newVal) => {
                                                    const newServiceTypes = newVal.split(SPLIT_DELIMITER)
                                                    setValue("serviceType", newServiceTypes);
                                                    clearErrors("serviceType");
                                                    if (callback !== null) {
                                                        callback(newServiceTypes)
                                                    }
                                                }}/>
                            );
                        }}/>
                </div>
            </div>

            {
                errors.serviceType &&
                <div className="text-red-700">
                    Please select “Service Type” before submitting
                </div>
            }
        </div>
    );
}
